import React from 'react';
import { styled, Theme } from '@material-ui/core/styles';

type CheckboxInputProps = {
  id: string;
  children: React.ReactNode;
};

const Label = styled('label')(({ theme }: { theme: Theme }) => ({
  display: 'block',
  position: 'relative',
  paddingLeft: '40px',
  marginBottom: '12px',
  cursor: 'pointer',
  userSelect: 'none',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  marginRight: '30px',
  letterSpacing: 'normal',
  color: '#4a4950',
  '-webkit-user-select': 'none',
  '-moz-user-select': 'none',
  '-ms-user-select': 'none',

  '& input': {
    position: 'absolute',
    height: 0,
    width: 0,
    visibility: 'hidden',
  },

  '& input:checked ~ .checkmark': {
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },

  '& .checkmark': {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '20px',
    width: '20px',
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.text.primary}`,
    borderRadius: '4px',
  },

  '& input:checked ~ .checkmark::after': {
    content: '""',
    position: 'absolute',
    top: '4px',
    left: '7px',
    width: '4px',
    height: '8px',
    border: `solid ${theme.palette.primary.contrastText}`,
    borderWidth: '0 2px 2px 0',
    '-webkit-transform': 'rotate(45deg)',
    '-ms-transform': 'rotate(45deg)',
    transform: 'rotate(45deg)',
  },
}));

const CheckboxInput = React.forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({ id, children }, ref) => (
    <Label htmlFor={id}>
      {children}

      <input id={id} type="checkbox" ref={ref} />
      <span className="checkmark" />
    </Label>
  ),
);

export default CheckboxInput;
